module.exports = __webpack_public_path__ + "media/components/src/assets/images/text_type_3-d9eaa3574dd82be00c35a7983469740c.jpg";